<template>
  <!-- prettier-ignore -->
  <div class="comparison-link">
    <ovp-button
plain
@click="open">
      <slot />
    </ovp-button>

    <ovp-modal
      v-model="show"
      open>
      <comparison-content
        class="comparison-modal"
        :content="content"
        :product="product"
        :type="type"
      />
    </ovp-modal>
  </div>
</template>

<script>
import ComparisonContent from '@/components/Comparison/Content'
import OvpModal from '@/components/Modal/Modal'

import { EVENT_PRODUCT_DETAIL_OPEN } from '@/config/events'

export default {
  name: 'ComparisonLink',

  components: {
    OvpModal,
    ComparisonContent,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },

    source: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      this.show = true

      this.$EventBus.$emit(EVENT_PRODUCT_DETAIL_OPEN, {
        categoryId: this.categoryId,
        productId: this.product.id,
        type: this.type,
        source: this.source,
      })
    },
  },
}
</script>

<style scoped>
.comparison-link {
  display: inline-block;
  color: var(--c-black);
  width: 100%;
  min-height: 50px;

  .button {
    border: 0;
    padding: 0;
    height: 25px;
    min-height: 25px;
    font-weight: bold;
    justify-content: flex-start;
    color: var(--c-original-green);
  }
}

.comparison-modal {
  padding: 15px;
}
</style>
